import { publicApi } from '../../client';

export interface CreateNewPasswordParams {
  email: string;
  newPassword: string;
  recoveryCode: string;
}

export async function createNewPasswordRequest(params: CreateNewPasswordParams): Promise<void> {
  await publicApi.post('/api/v1/auth/new-password', params);
}
